import { Box, Divider, Typography } from "@mui/material";
import { ReactElement } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  title?: string | undefined;
  children: ReactElement[] | ReactElement;
  translationKey?: string | undefined;
  noBorder?: boolean;
};

const PreviewSectionContainer = ({
  children,
  title = undefined,
  translationKey = undefined,
  noBorder = false,
}: Props) => {
  const { t } = useTranslation();
  return (
    <>
      <Box sx={{ padding: "20px 0" }}>
        {translationKey && title && (
          <Typography variant="header" mb={1} sx={{ fontWeight: 700 }}>
            {t(`${translationKey}:${title}`)}
          </Typography>
        )}
        {children}
      </Box>
      {!noBorder && <Divider />}
    </>
  );
};

export default PreviewSectionContainer;
